// extracted by mini-css-extract-plugin
module.exports = {"fuel-consumption-data":"style_fuel-consumption-data__2nQ8I"};